
import Vue from "vue";
import { fetchWithBackoff } from "../../utils/fetchWithBackoff";

const TenantAPIService = class extends Vue {
  _DEBUG = false;

  constructor() {
    super();
    if (this._DEBUG) {
      this.debugMessage('BOOTSTRAPPED TENANT API SERVICE');
    }
  }

  debugMessage(message) {
    if (this._DEBUG) {
      console.log(message);
    }
  }

  async fetchTenants() {
    if (!config) return;

    const claims = await this.$auth.getIdTokenClaims();
    const id_token = claims.__raw;
    if (!id_token) return;

    const url = `${config.TENET_SERVICE}/tenants/?list=true`;
    const request = new Request(url, {
      method: "GET",
      mode: "cors",
      cache: "default",
      withCredentials: true,
      credentials: "include",
      headers: {
        Authorization: "Bearer " + id_token,
        "Content-Type": "application/json",
      },
    });

    return fetchWithBackoff(request);
  }
};

// Singleton Pattern Instantiate
if (!Vue.prototype.$TenantAPIService) {
  Vue.prototype.$TenantAPIService = new TenantAPIService();
}

export default Vue.prototype.$TenantAPIService;
